var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4860_787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.866 14.85C2.788 15.294 3.226 15.641 3.612 15.443L8.002 13.187L12.391 15.443C12.777 15.641 13.215 15.294 13.137 14.851L12.307 10.121L15.829 6.76505C16.159 6.45105 15.989 5.87705 15.547 5.81505L10.649 5.11905L8.465 0.792045C8.42339 0.704334 8.35775 0.630228 8.27571 0.578338C8.19366 0.526447 8.09857 0.498901 8.0015 0.498901C7.90442 0.498901 7.80933 0.526447 7.72729 0.578338C7.64524 0.630228 7.5796 0.704334 7.538 0.792045L5.354 5.12005L0.455996 5.81605C0.0149962 5.87805 -0.156004 6.45204 0.172996 6.76605L3.696 10.122L2.866 14.852V14.85ZM7.771 12.083L4.085 13.977L4.779 10.02C4.7957 9.92896 4.78956 9.83514 4.76111 9.74701C4.73266 9.65888 4.6828 9.57918 4.616 9.51505L1.71 6.74505L5.762 6.16905C5.84576 6.15597 5.92517 6.123 5.99355 6.07288C6.06194 6.02277 6.1173 5.95698 6.155 5.88105L8 2.22305L9.847 5.88105C9.88469 5.95698 9.94006 6.02277 10.0084 6.07288C10.0768 6.123 10.1562 6.15597 10.24 6.16905L14.292 6.74405L11.386 9.51404C11.319 9.57828 11.2691 9.65815 11.2406 9.74647C11.2122 9.83479 11.2061 9.9288 11.223 10.02L11.917 13.977L8.231 12.083C8.15979 12.0461 8.08073 12.0267 8.0005 12.0267C7.92026 12.0267 7.8422 12.0461 7.771 12.083Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4860_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.4e738c0d58fca3bb130166ee3e698c9b.svg";
export { ForwardRef as ReactComponent };